import { Script } from 'gatsby';
import React from 'react';
import { useGetDrupalCustomConfig } from 'src/hooks/useGetDrupalCustomConfig';
import { SmartScriptHandler } from './SmartScriptHandler';

export const AppsFlyer = ({ langcode }: { langcode: Languages }) => {
  const appsflyerSettings = useGetDrupalCustomConfig(langcode)?.nerd_appsflyer_settings;

  if (!appsflyerSettings) {
    return null;
  }

  const { onelink_domain: domain, smartscript_sdk_script: sdkScript } = appsflyerSettings;

  if (!domain || !sdkScript) {
    return null;
  }

  return (
    <>
      {/* Src pulled from https://github.com/AppsFlyerSDK/appsflyer-onelink-smart-script */}
      <Script
        type="text/javascript"
        id="appsflyer-smartscript-sdk"
        defer
        src="https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js"
      />
      <SmartScriptHandler script={sdkScript} domain={domain} />
    </>
  );
};
